export default [
   {
      name: "Wallis and Futuna",
      code: "681"
   },
   {
      name: "Iceland",
      code: "354"
   },
   {
      name: "Luxembourg",
      code: "352"
   },
   {
      name: "Mali",
      code: "223"
   },
   {
      name: "Comoros",
      code: "269"
   },
   {
      name: "Australia",
      code: "61"
   },
   {
      name: "Estonia",
      code: "372"
   },
   {
      name: "Canada",
      code: "1"
   },
   {
      name: "Belarus",
      code: "375"
   },
   {
      name: "Guyana",
      code: "592"
   },
   {
      name: "Gambia",
      code: "220"
   },
   {
      name: "Tunisia",
      code: "216"
   },
   {
      name: "Cameroon",
      code: "237"
   },
   {
      name: "Rwanda",
      code: "250"
   },
   {
      name: "Cambodia",
      code: "855"
   },
   {
      name: "Benin",
      code: "229"
   },
   {
      name: "Greece",
      code: "30"
   },
   {
      name: "South Korea",
      code: "82"
   },
   {
      name: "Mauritius",
      code: "230"
   },
   {
      name: "United States Virgin Islands",
      code: "1340"
   },
   {
      name: "Åland Islands",
      code: "35818"
   },
   {
      name: "San Marino",
      code: "378"
   },
   {
      name: "Maldives",
      code: "960"
   },
   {
      name: "Vanuatu",
      code: "678"
   },
   {
      name: "Malawi",
      code: "265"
   },
   {
      name: "Egypt",
      code: "20"
   },
   {
      name: "Senegal",
      code: "221"
   },
   {
      name: "Georgia",
      code: "995"
   },
   {
      name: "New Zealand",
      code: "64"
   },
   {
      name: "Cape Verde",
      code: "238"
   },
   {
      name: "Italy",
      code: "39"
   },
   {
      name: "Monaco",
      code: "377"
   },
   {
      name: "Slovakia",
      code: "421"
   },
   {
      name: "Uruguay",
      code: "598"
   },
   {
      name: "Laos",
      code: "856"
   },
   {
      name: "Faroe Islands",
      code: "298"
   },
   {
      name: "Niue",
      code: "683"
   },
   {
      name: "North Macedonia",
      code: "389"
   },
   {
      name: "Chile",
      code: "56"
   },
   {
      name: "Cyprus",
      code: "357"
   },
   {
      name: "Macau",
      code: "853"
   },
   {
      name: "El Salvador",
      code: "503"
   },
   {
      name: "Jordan",
      code: "962"
   },
   {
      name: "Jamaica",
      code: "1876"
   },
   {
      name: "Barbados",
      code: "1246"
   },
   {
      name: "Western Sahara",
      code: "2125288"
   },
   {
      name: "Qatar",
      code: "974"
   },
   {
      name: "Guatemala",
      code: "502"
   },
   {
      name: "Micronesia",
      code: "691"
   },
   {
      name: "Montserrat",
      code: "1664"
   },
   {
      name: "Papua New Guinea",
      code: "675"
   },
   {
      name: "Brazil",
      code: "55"
   },
   {
      name: "Lithuania",
      code: "370"
   },
   {
      name: "French Guiana",
      code: "594"
   },
   {
      name: "Moldova",
      code: "373"
   },
   {
      name: "Kyrgyzstan",
      code: "996"
   },
   {
      name: "Curaçao",
      code: "599"
   },
   {
      name: "Vietnam",
      code: "84"
   },
   {
      name: "Angola",
      code: "244"
   },
   {
      name: "Malaysia",
      code: "60"
   },
   {
      name: "Switzerland",
      code: "41"
   },
   {
      name: "Thailand",
      code: "66"
   },
   {
      name: "Dominican Republic",
      code: "1809"
   },
   {
      name: "Uzbekistan",
      code: "998"
   },
   {
      name: "Chad",
      code: "235"
   },
   {
      name: "Cocos (Keeling) Islands",
      code: "61"
   },
   {
      name: "Guinea",
      code: "224"
   },
   {
      name: "Turks and Caicos Islands",
      code: "1649"
   },
   {
      name: "Puerto Rico",
      code: "1787"
   },
   {
      name: "Bhutan",
      code: "975"
   },
   {
      name: "Cayman Islands",
      code: "1345"
   },
   {
      name: "Marshall Islands",
      code: "692"
   },
   {
      name: "Anguilla",
      code: "1264"
   },
   {
      name: "Mauritania",
      code: "222"
   },
   {
      name: "Norway",
      code: "47"
   },
   {
      name: "Martinique",
      code: "596"
   },
   {
      name: "Israel",
      code: "972"
   },
   {
      name: "Saint Barthélemy",
      code: "590"
   },
   {
      name: "Ecuador",
      code: "593"
   },
   {
      name: "Grenada",
      code: "1473"
   },
   {
      name: "Croatia",
      code: "385"
   },
   {
      name: "Brunei",
      code: "673"
   },
   {
      name: "Iraq",
      code: "964"
   },
   {
      name: "Japan",
      code: "81"
   },
   {
      name: "Lesotho",
      code: "266"
   },
   {
      name: "Tuvalu",
      code: "688"
   },
   {
      name: "Heard Island and McDonald Islands",
      code: "undefined"
   },
   {
      name: "Finland",
      code: "358"
   },
   {
      name: "South Sudan",
      code: "211"
   },
   {
      name: "United States Minor Outlying Islands",
      code: "268"
   },
   {
      name: "Saint Helena, Ascension and Tristan da Cunha",
      code: "290"
   },
   {
      name: "Afghanistan",
      code: "93"
   },
   {
      name: "Solomon Islands",
      code: "677"
   },
   {
      name: "China",
      code: "86"
   },
   {
      name: "Eritrea",
      code: "291"
   },
   {
      name: "Russia",
      code: "73"
   },
   {
      name: "Andorra",
      code: "376"
   },
   {
      name: "Armenia",
      code: "374"
   },
   {
      name: "Austria",
      code: "43"
   },
   {
      name: "Suriname",
      code: "597"
   },
   {
      name: "Spain",
      code: "34"
   },
   {
      name: "Tokelau",
      code: "690"
   },
   {
      name: "Bahamas",
      code: "1242"
   },
   {
      name: "Sint Maarten",
      code: "1721"
   },
   {
      name: "Belize",
      code: "501"
   },
   {
      name: "Jersey",
      code: "44"
   },
   {
      name: "Sweden",
      code: "46"
   },
   {
      name: "Botswana",
      code: "267"
   },
   {
      name: "Isle of Man",
      code: "44"
   },
   {
      name: "United Arab Emirates",
      code: "971"
   },
   {
      name: "Iran",
      code: "98"
   },
   {
      name: "Gabon",
      code: "241"
   },
   {
      name: "Saint Kitts and Nevis",
      code: "1869"
   },
   {
      name: "Equatorial Guinea",
      code: "240"
   },
   {
      name: "São Tomé and Príncipe",
      code: "239"
   },
   {
      name: "Greenland",
      code: "299"
   },
   {
      name: "Bangladesh",
      code: "880"
   },
   {
      name: "Romania",
      code: "40"
   },
   {
      name: "British Indian Ocean Territory",
      code: "246"
   },
   {
      name: "Sudan",
      code: "249"
   },
   {
      name: "Bosnia and Herzegovina",
      code: "387"
   },
   {
      name: "Malta",
      code: "356"
   },
   {
      name: "Seychelles",
      code: "248"
   },
   {
      name: "Sri Lanka",
      code: "94"
   },
   {
      name: "Mexico",
      code: "52"
   },
   {
      name: "Yemen",
      code: "967"
   },
   {
      name: "British Virgin Islands",
      code: "1284"
   },
   {
      name: "Netherlands",
      code: "31"
   },
   {
      name: "Paraguay",
      code: "595"
   },
   {
      name: "United Kingdom",
      code: "44"
   },
   {
      name: "Venezuela",
      code: "58"
   },
   {
      name: "Bouvet Island",
      code: "47"
   },
   {
      name: "Ukraine",
      code: "380"
   },
   {
      name: "Morocco",
      code: "212"
   },
   {
      name: "Portugal",
      code: "351"
   },
   {
      name: "Pakistan",
      code: "92"
   },
   {
      name: "Saint Vincent and the Grenadines",
      code: "1784"
   },
   {
      name: "North Korea",
      code: "850"
   },
   {
      name: "Slovenia",
      code: "386"
   },
   {
      name: "Ivory Coast",
      code: "225"
   },
   {
      name: "Palestine",
      code: "970"
   },
   {
      name: "Caribbean Netherlands",
      code: "599"
   },
   {
      name: "Belgium",
      code: "32"
   },
   {
      name: "Zimbabwe",
      code: "263"
   },
   {
      name: "Tanzania",
      code: "255"
   },
   {
      name: "Togo",
      code: "228"
   },
   {
      name: "Cook Islands",
      code: "682"
   },
   {
      name: "Guadeloupe",
      code: "590"
   },
   {
      name: "New Caledonia",
      code: "687"
   },
   {
      name: "Saint Lucia",
      code: "1758"
   },
   {
      name: "South Georgia",
      code: "500"
   },
   {
      name: "Poland",
      code: "48"
   },
   {
      name: "Samoa",
      code: "685"
   },
   {
      name: "Czechia",
      code: "420"
   },
   {
      name: "Indonesia",
      code: "62"
   },
   {
      name: "Bolivia",
      code: "591"
   },
   {
      name: "Colombia",
      code: "57"
   },
   {
      name: "Honduras",
      code: "504"
   },
   {
      name: "Denmark",
      code: "45"
   },
   {
      name: "Central African Republic",
      code: "236"
   },
   {
      name: "Libya",
      code: "218"
   },
   {
      name: "Guinea-Bissau",
      code: "245"
   },
   {
      name: "Mongolia",
      code: "976"
   },
   {
      name: "DR Congo",
      code: "243"
   },
   {
      name: "Falkland Islands",
      code: "500"
   },
   {
      name: "Nauru",
      code: "674"
   },
   {
      name: "Syria",
      code: "963"
   },
   {
      name: "Montenegro",
      code: "382"
   },
   {
      name: "France",
      code: "33"
   },
   {
      name: "Zambia",
      code: "260"
   },
   {
      name: "Myanmar",
      code: "95"
   },
   {
      name: "Saint Pierre and Miquelon",
      code: "508"
   },
   {
      name: "Costa Rica",
      code: "506"
   },
   {
      name: "Somalia",
      code: "252"
   },
   {
      name: "Ireland",
      code: "353"
   },
   {
      name: "French Polynesia",
      code: "689"
   },
   {
      name: "Pitcairn Islands",
      code: "64"
   },
   {
      name: "Hungary",
      code: "36"
   },
   {
      name: "Turkey",
      code: "90"
   },
   {
      name: "Oman",
      code: "968"
   },
   {
      name: "Guam",
      code: "1671"
   },
   {
      name: "Nepal",
      code: "977"
   },
   {
      name: "Liechtenstein",
      code: "423"
   },
   {
      name: "Madagascar",
      code: "261"
   },
   {
      name: "Kazakhstan",
      code: "76"
   },
   {
      name: "Djibouti",
      code: "253"
   },
   {
      name: "Gibraltar",
      code: "350"
   },
   {
      name: "Guernsey",
      code: "44"
   },
   {
      name: "Namibia",
      code: "264"
   },
   {
      name: "Republic of the Congo",
      code: "242"
   },
   {
      name: "Germany",
      code: "49"
   },
   {
      name: "Vatican City",
      code: "3906698"
   },
   {
      name: "French Southern and Antarctic Lands",
      code: "262"
   },
   {
      name: "Albania",
      code: "355"
   },
   {
      name: "Algeria",
      code: "213"
   },
   {
      name: "Mayotte",
      code: "262"
   },
   {
      name: "Haiti",
      code: "509"
   },
   {
      name: "Svalbard and Jan Mayen",
      code: "4779"
   },
   {
      name: "Tonga",
      code: "676"
   },
   {
      name: "Hong Kong",
      code: "852"
   },
   {
      name: "Singapore",
      code: "65"
   },
   {
      name: "Antigua and Barbuda",
      code: "1268"
   },
   {
      name: "Saudi Arabia",
      code: "966"
   },
   {
      name: "Cuba",
      code: "53"
   },
   {
      name: "Panama",
      code: "507"
   },
   {
      name: "Liberia",
      code: "231"
   },
   {
      name: "Azerbaijan",
      code: "994"
   },
   {
      name: "Latvia",
      code: "371"
   },
   {
      name: "Antarctica",
      code: "undefined"
   },
   {
      name: "Kiribati",
      code: "686"
   },
   {
      name: "Ethiopia",
      code: "251"
   },
   {
      name: "Niger",
      code: "227"
   },
   {
      name: "Trinidad and Tobago",
      code: "1868"
   },
   {
      name: "Sierra Leone",
      code: "232"
   },
   {
      name: "Mozambique",
      code: "258"
   },
   {
      name: "Palau",
      code: "680"
   },
   {
      name: "Fiji",
      code: "679"
   },
   {
      name: "Réunion",
      code: "262"
   },
   {
      name: "Norfolk Island",
      code: "672"
   },
   {
      name: "Turkmenistan",
      code: "993"
   },
   {
      name: "Tajikistan",
      code: "992"
   },
   {
      name: "Lebanon",
      code: "961"
   },
   {
      name: "Nigeria",
      code: "234"
   },
   {
      name: "United States",
      code: "1201"
   },
   {
      name: "Argentina",
      code: "54"
   },
   {
      name: "Burkina Faso",
      code: "226"
   },
   {
      name: "Christmas Island",
      code: "61"
   },
   {
      name: "Bermuda",
      code: "1441"
   },
   {
      name: "Nicaragua",
      code: "505"
   },
   {
      name: "Eswatini",
      code: "268"
   },
   {
      name: "Bahrain",
      code: "973"
   },
   {
      name: "Kenya",
      code: "254"
   },
   {
      name: "Serbia",
      code: "381"
   },
   {
      name: "Timor-Leste",
      code: "670"
   },
   {
      name: "Dominica",
      code: "1767"
   },
   {
      name: "Northern Mariana Islands",
      code: "1670"
   },
   {
      name: "Philippines",
      code: "63"
   },
   {
      name: "Kosovo",
      code: "383"
   },
   {
      name: "Kuwait",
      code: "965"
   },
   {
      name: "Taiwan",
      code: "886"
   },
   {
      name: "Burundi",
      code: "257"
   },
   {
      name: "American Samoa",
      code: "1684"
   },
   {
      name: "Bulgaria",
      code: "359"
   },
   {
      name: "South Africa",
      code: "27"
   },
   {
      name: "Peru",
      code: "51"
   },
   {
      name: "Aruba",
      code: "297"
   },
   {
      name: "Ghana",
      code: "233"
   },
   {
      name: "Saint Martin",
      code: "590"
   },
   {
      name: "India",
      code: "91"
   },
   {
      name: "Uganda",
      code: "256"
   }
].sort((a, b) => a.name.localeCompare(b.name));
